import * as Validators from "./validators";
import { TX_STATES } from "../redux/Tx/constants";

export const getFilteredChildrenRecursive = (list) => {
    let nodes = [];
    for (let i = 0; i < list.childrenAfterFilter.length; i++) {
        const node = list.childrenAfterFilter[i];
        if (!node.data) continue;
        if (node.childrenAfterFilter?.length > 0)
            nodes = nodes.concat(getFilteredChildrenRecursive(node));
        else {
            nodes.push(node);
        }
    }
    return nodes;
};

export const getChildrenNode = (rootNode, nodeName) => {
    const nodes = rootNode[nodeName] || [];
    return nodes.reduce((result, node) => {
        if (node.data) {
            result.push(node.data);
            return result;
        }
        return result.concat(getChildrenNode(node, nodeName));
    }, []);
};

export const getValuesFromNode = (params) => {
    if (!params.data) {
        return {
            ticker: params.node.aggData["Details Ticker"],
            borrower: params.node.aggData["Details Borrower"],
            lender: params.node.aggData["Details Lender"],
        };
    } else {
        return {
            ticker: params.data.Ticker,
            borrower: params.data.Borrower,
            lender: params.data.Lender,
        };
    }
};
export const aggId = (params) => {
    return params.rowNode.key;
};

export const aggRate = (params) => {
    try {
        // Skip aggregation for portfolio trade parent rows
        if (params.rowNode.data?.isPortfolioTrade) {
            return params.value;
        }

        const list = getFilteredChildrenRecursive(params.rowNode).filter(
            (n) =>
                Validators.isQuantityValid(n.data.OfferQuantity) &&
                Validators.isRateValid(n.data.OfferRate) &&
                n.data.Status !== TX_STATES.REJECTED &&
                n.data.Status !== TX_STATES.EXPIRED &&
                n.data.Status !== TX_STATES.CANCELLED
        );

        let denominator = 0;
        let numerator = 0;

        for (let i = 0; i < list.length; i++) {
            const data = list[i].data;
            if (!data) continue;
            const qty = parseInt(data.OfferQuantity);
            const rate = parseFloat(data.OfferRate);
            if (!isNaN(qty) && qty !== 0 && !isNaN(rate)) {
                denominator += qty;
                numerator += rate * qty;
            }
        }
        return numerator / denominator;
    } catch (e) {
        return null;
    }
};

export const aggSum = (params) => {
    // Skip aggregation for portfolio trade parent rows
    if (params.rowNode.data?.isPortfolioTrade) {
        return params.value;
    }

    const fieldName = params.colDef.field;
    const list = getFilteredChildrenRecursive(params.rowNode);
    const amountMap = list
        .map((node) =>
            node.data[fieldName] ? parseInt(node.data[fieldName]) : null
        )
        .filter((n) => !isNaN(n) && n !== null);
    if (amountMap.length === 0) return null;
    return amountMap.reduce((total, value) => {
        return value + total;
    }, 0);
};

export const aggName = (params) => {
    // Skip aggregation for portfolio trade parent rows
    if (params.rowNode.data?.isPortfolioTrade) {
        return params?.values?.[0];
    }

    const fieldName = params.colDef.field;
    const data = getFilteredChildrenRecursive(params.rowNode);
    const arr = [
        ...new Set(data.map((node) => JSON.stringify(node.data[fieldName]))),
    ];
    return arr.length === 1 ? data[0].data[fieldName] : null;
};

export const aggOrigin = (params) => {
    // Skip aggregation for portfolio trade parent rows
    if (params.rowNode.data?.isPortfolioTrade) {
        return params.value;
    }

    if (params.rowNode.key) {
        const children = (params?.rowNode?.childrenAfterFilter || [])[0];
        const origin = children?.data?.ParentData;
        return origin ? origin[params.colDef.field] : params.value;
    }
    return params.value;
};

export const aggType = (params) => {
    return aggName(params) || "MIXED";
};

export function processExportOutput(params) {
    if (params.value === "HOLD") {
        return "EA";
    } else {
        return params.value;
    }
}
